import request from '@/utils/request';

// 修改手机号的发送验证码
export function sendCodeByChangePhone(data) {
  return request({
    url: '/system/front/account/sendUpUsernameCode',
    method: 'post',
    data
  });
}

// 修改手机号并保存
export function saveNewPhone(data) {
  return request({
    url: '/system/front/account/updateUsername',
    method: 'post',
    data
  });
}

// 修改密码
export function updateUserPsw(data) {
  return request({
    url: '/system/front/account/editPassword',
    method: 'post',
    data
  });
}

// 解绑教职工认证获取验证码
export function unbindStaffCode(data) {
  return request({
    url: '/system/front/sms/validateCode',
    method: 'post',
    data
  });
}

// 解绑教职工认证
export function unbindStaff(data) {
  return request({
    url: '/system/front/authentication/unBind',
    method: 'post',
    data
  });
}

// 绑定教职工认证
export function bindStaff(params) {
  return request({
    url: '/system/front/authentication/eduStaffCheck',
    method: 'get',
    params
  });
}



// WEBPACK FOOTER //
// ./src/api/setting/index.js